<template>
  <div v-if="section.epi.show">
    <form-set-generic
      v-model="curriculum.epi"
      label="curriculum"
      form="admissional"
      section="epi"
      :fields="fields"
      class="profile-subsection"
    />

  </div>
</template>

<script>
import { useCurriculum } from '@state/user/curriculum'
import FormSetGeneric from '@components/forms/set/Generic.vue'
import { FormFieldSwitch } from '@components/forms'

export default {
  components: {
    FormSetGeneric,
    FormFieldSwitch
  },
  setup() {
    const curriculum = useCurriculum()
    return {
      // you can return the whole store instance to use it in the template
      curriculum
    }
  },
  props : {
    section : {
      type : Object,
      required: true
    }
  },
  computed : {
    fields() {
      return this.section.epi.fields;
    }
  }
};
</script>
